import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Upload, Tooltip, message, notification } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { IMaterialDetailModel, useSaleSoDetailModel } from "./saleSoDetailModel";
import { RouterParamType } from "@/model/navModel";
import { DetailType, ISalesTypeEnum, IPriceTypeEnum } from "@/types/ScmEnums";
import { IDetailList } from "../../saleSoTypes";
import { formatNum, formatIntPoint, formatIntPoint1 } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import useGlobalModel from "@/model/globalModel";
import { YhBut } from "@/components/YhButton";
import { debounce } from "lodash";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { useDictModel } from "@/views/base/dict/dictModel";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";

export const TableBox: FC<RouterParamType> = ({ id, mode, parentInfo }) => {
    const { shopAndOrg: { shopId }, user: { roles }, setLoadingInfo, getSettlementParty } = useGlobalModel()
    const { getRoleColumns } = roleColumnModel();
    const {
        detailAddForm,
        setAddModalVisible,
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        setDetaiAddDataRow,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataSource,
        detailDetailList,
        downloadTpl,
        transformsToPoDetailList,
        setTopButsControl,
        setHistoryVisible,
        setHistoryRow
    } = useSaleSoDetailModel();
    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    let { priceTypeCode, salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;

    const importCallback = async (list: IMaterialDetailModel[]) => {
        if (!list) return;
        let newImportList = await Promise.all(list.map(async (item: any) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, retailPrice, num, petroleumPrice, ...params } = item as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, petroleumPrice: number, stockId: string }
            let newPrice: number = latestPurPrice ?? purchasePrice;
            if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = lateSalePrice ?? retailPrice;
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = retailPrice;
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = latestPurPrice ?? purchasePrice;
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = purchasePrice ?? latestPurPrice;
                        break;
                    //售价选择 石油价格
                    case IPriceTypeEnum.PETROLEUM:
                        newPrice = petroleumPrice ?? purchasePrice
                        break;
                }
            }
            return {
                ...item,
                id: stockId,
                num,
                price: newPrice,
            }
        }))
        transformsToPoDetailList(mode, newImportList)
    }
    const upLoadCallback = (list: any) => {
        setLoadingInfo({ loadingVisible: false, txt: '' })
        if (list && list.length) {
            let str = ""
            let newData: any = []
            list.map((lists: any, index: any) => {
                if (lists.status) {
                    lists.details.map(async (item: any) => {
                        let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, retailPrice, num, petroleumPrice, ...params } = item as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, petroleumPrice: number, stockId: string }
                        let newPrice: number = latestPurPrice ?? purchasePrice;
                        if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
                            switch (priceTypeCode) {
                                //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                                case IPriceTypeEnum.CUSTOMER_LATEST:
                                    purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string).then(({ retData }) => {
                                        newPrice = +retData.price;
                                    })
                                    break;
                                //售价选择 最近销价 
                                case IPriceTypeEnum.RECENT:
                                    newPrice = lateSalePrice ?? retailPrice;
                                    break;
                                //售价选择 零售价
                                case IPriceTypeEnum.RETAIL:
                                    newPrice = retailPrice;
                                    break;
                                //售价选择 采购成本价
                                case IPriceTypeEnum.PUR_COST:
                                    newPrice = latestPurPrice ?? purchasePrice;
                                    break;
                                //售价选择 档案进价
                                case IPriceTypeEnum.BUYING_PRICE:
                                    newPrice = purchasePrice ?? latestPurPrice;
                                    break;
                                //售价选择 石油价格
                                case IPriceTypeEnum.PETROLEUM:
                                    newPrice = petroleumPrice ?? purchasePrice
                                    break;
                            }
                        }
                        newData.push({
                            ...item,
                            id: stockId,
                            num,
                            price: newPrice,
                        })
                    })
                }
                else {
                    str += `【第${index + 1}条导入失败：${lists.msg}】`;
                }
            })
            transformsToPoDetailList(mode, newData)
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success("导入成功")
        }
    }
    const materialTips = (info: string, visible: boolean) => {
        globalPrompt("modal", {
            title: "新增维修用料",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { visible && await setAddModalVisible(visible) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const isEditable = (status: string) => {
        if (mode === "look") return false;
        if (mode === "add") return true;

        if (mode === "edit" &&
            status === DictCodeEnmu.SALE_STATUS_STOCK_IO ||
            status === DictCodeEnmu.SALE_STATUS_SETTLE || status === "d-sale-status.paying"
        ) {
            return false
        }
        return true;
    }

    // 删除(做限制)
    const onRemove = (mode: string) => {
        detailDetailList(mode)
    }
    const action =
        <>
            {isEditable(detailEditForm.status as string) && <>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_ADD_M}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={async () => {
                            // debugger
                            // setAddModalVisible(true)
                            let { salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
                            if (!salesTypeCode || !customerCode) {
                                message.warning("请补全客户名称和销售类型");
                                return false
                            }
                            // if (mode === "add") {
                            //     let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailAddForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                            //     if (!(customerCode && customerName && payType && settlementPartyCode)) {
                            //         message.warning("请补全客户名称或结算类型或结算方")
                            //         return false
                            //     }
                            //     let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });
                            //     if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
                            //         if(accountName && availableAmount < 0){
                            //             message.warning(`当前${accountName},授信额度为${availableAmount},请处理完账户的负数余额后，在进行开单操作！！！`)
                            //             return;
                            //         }
                            //         if (accountName && availableAmount > 0) {//有账户，但是额度大于开单金额的
                            //             materialTips(`当前${accountName},授信额度为${availableAmount},是否确认？？`, true)
                            //         } else if (accountName && availableAmount === 0) {
                            //             materialTips(`当前${accountName},授信额度为${availableAmount}，不可开单，是否确认？？`, false)
                            //         } else if (!accountName) {
                            //             materialTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                            //         }
                            //     } else {
                            //         setAddModalVisible(true) 
                            //     }
                            // } else {
                            setAddModalVisible(true)
                            // }
                        }}
                    >新增商品</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_DEL_M}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={() => { onRemove(mode) }}
                    >删除商品</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_IM}>
                    <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/sale/details/importPro`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }), { shopId }, false)}>
                        <Button
                            disabled={!(salesTypeCode && customerCode)}
                            className="mr-5"
                            type="primary"
                            shape="round">导入</Button>
                    </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_DLOAD}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={downloadTpl}
                    >下载模板</Button>
                </YhAuth>
            </>}
        </>

    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
            render: (text: any, record: any) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
            sorter: {
                compare: (a: { materialCode: string; }, b: { materialCode: string; }) => a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0),
                multiple: 1,
            },
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
            sorter: {
                compare: (a: any, b: any) => a.materialName.localeCompare(b.materialName, 'zh-Hans-CN', { sensitivity: 'accent' }),
                multiple: 2,
            },
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
        }, {
            title: '销售数量',
            width: 100,
            dataIndex: 'num',
            editable: isEditable(detailEditForm.status as string)
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: isEditable(detailEditForm.status as string),
            render: (text: any) => text < 0 ? `-￥${formatNum(text)}` : `￥${formatNum(text)}`
        }, {
            title: '销售金额',
            width: 100,
            dataIndex: 'totalAmount',
            render: (text: any) => text < 0 ? `-￥${formatNum(text)}` : `￥${formatNum(text)}`
            // render: (text:any) => formatNum(text)
        }, {
            title: '折扣',
            width: 100,
            dataIndex: 'discountRate',
            editable: isEditable(detailEditForm.status as string),
            suffix: "%",
            render: (text: string) => text + '%'
        }, {
            title: '折后金额',
            width: 100,
            dataIndex: 'discountedAmount',
            render: (text: any) => `￥${formatNum(text)}`
        },
        {
            title: '单项优惠金额',
            width: 140,
            dataIndex: 'decreaseAmount',
            editable: isEditable(detailEditForm.status as string),
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
            render: (text: any) => text < 0 ? `-￥${formatNum(text)}` : `￥${formatNum(text)}`
        },
        {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isEditable(detailEditForm.status as string),
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isEditable(detailEditForm.status as string) && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
        }
    ];

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }

    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "sale", "roleCodes": roles };
        return getRoleColumns("sale", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);

    const handleSave = (row: IDetailList) => {
        let { num, price, discountRate, inventoryNum, purchasePrice, latestPurPrice, termNum, decreaseAmount, receivableAmount, discountedAmount } = row
        let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : purchasePrice
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        num = mode === "add" ? parentInfo ? +formatIntPoint(num) : +formatIntPoint(num, inventoryNum, "选择数量>=可用库存数量") : parentInfo ? +formatIntPoint(num) : +formatIntPoint(num, termNum ? termNum : inventoryNum, "选择数量>=可用库存数量");  //数量
        price = +formatIntPoint1(price, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);  //价格
        price = +formatNum(price);
        discountedAmount = +formatNum((num * price * discountRate) / 100)
        // decreaseAmount = +formatIntPoint(decreaseAmount, 1, '单项优惠金额不能大于1元')
        receivableAmount = +formatNum(discountedAmount - ((decreaseAmount || 0) * 1))
        let newRow = {
            ...row,
            price,
            discountRate,
            num,
            decreaseAmount,
            totalAmount: +formatNum(num * price),
            discountedAmount,
            receivableAmount
        }
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];

        //判断仓库变化时，  重置货位
        // if (newRow.warehouseCode !== newData[index].warehouseCode) {
        //     newRow.shelfCode = undefined
        // }
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }

    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.detailsId as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}